import React, { useState } from 'react';
import * as Icons from '../Icons';

const Services = () => {
  return (
    <section className="section-services sticker section-padding" id="services">
      <div className="container">
        <div className="section-heading text-center">
          <h2 className="title">
            Our Services
          </h2>
        </div>
        <div className="row">
          <div className="text service-item pl-3 pr-3">
            EnjoyFresh is a unique concept. It's a congregation of food-lovers, and the app is a virtual food hub. You can download it right away on your android or iOS device, register as a Food Seller, and start selling your food to the people who know the delight of savoring the right food!             </div>
          <div className="text service-item pl-3 pr-3">
            Not just the things mentioned above, the app helps you choose the closest food seller in your region, who can deliver/serve you the food product/dish you want.The
            food seller’s corner spells out
            in greater detail about the
            product what he/she has in the offering. Just think, the entire idea is delicious considering your love for food and time constraints.
          </div>
          <div className="text service-item pl-3 pr-3">
            EnjoyFresh also offers you the luxury of choosing food from nearby service provider and having it delivered it to your doorstep by an agile delivery agent. Not just this. You can buy food that is seasonal.
          </div>
          <div className="text service-item pl-3 pr-3">
            The app provides lovers and sellers of food a unique platform to showcase their entire food product portfolio, Purchase any item listed in the menu available within the vicinity of 5 kilometers!             </div>
        </div>
        <div className="row service-list">
          <div className="col-12 col-md-4 service-item text-center  wow fadeInUp" data-wow-duration="1s" data-wow-delay=".5s">
            <div className="media">
              <img src={Icons.serviceCook} alt="Chef" className="img-fluid mx-auto d-block" />
            </div>
            <div className="copy">
              <div className="title">
                Connect with the food seller or Restaurant
              </div>
              <div className="text">
                The EnjoyFresh app helps you connect with the Food Seller or Restaurant to know what is in the offering. Once you select your Restaurant/Chef, and place an order for a specific dish, the price will be displayed. You can even learn more about the Chef and the type of food he specializes in. Select the item, add it to your cart, and make the payment through authentic payment gateways.                 </div>
            </div>
          </div>
          <div className="col-12 col-md-4 service-item text-center  wow fadeInUp" data-wow-duration="1s" data-wow-delay=".6s">
            <div className="media">
              <img src={Icons.serviceDelivery} alt="Delivery" className="img-fluid mx-auto d-block" />
            </div>
            <div className="copy">
              <div className="title">
                Order Confirmation
              </div>
              <div className="text">
                Upon confirmation of the order by the Chef/the Restaurant, a delivery partner will be assigned instantly, and he will get your favorite food to your doorstep. The delivery time will be indicated through the location map. You can track your order in real-time!                 </div>
            </div>
          </div>
          <div className="col-12 col-md-4 service-item text-center  wow fadeInUp" data-wow-duration="1s" data-wow-delay=".7s">
            <div className="media">
              <img src={Icons.serviceFood} alt="Food" className="img-fluid mx-auto d-block" />
            </div>
            <div className="copy">
              <div className="title">
                Delivery At Your Door Step
              </div>
              <div className="text">
                The delivery partner will be at your door on time! Collect your favorite food from him and relish the freshest and tastiest food with your beloved!                 </div>
            </div>
          </div>
        </div>
      </div>
      <div className="dish-4">
        <img src={Icons.dish4} alt="" />
      </div>
    </section>

  )
};

export default Services;
